<script>
  import {getHomepage} from "../api/homepage";
  
  import Cookies from "./sub-components/Cookies.svelte";
  import {onMount} from "svelte";
  import {marked} from "marked";
  import { UPLOADS_DIRECTORY } from "../constants";

  const buttonColsValues = {
    1: 12,
    2: 6,
    3: 4
  };

  let data       = null;
  let buttonCols = 6;

  onMount(async() => {
    try {
      data = await getHomepage("landing");

      if(data.buttons.length in buttonColsValues) {
        buttonCols = buttonColsValues[data.buttons.length];
      }
    } catch(error) {
      console.error(error);
    }
  });

  function handleAnchorClick(event) {
    event.preventDefault();
    const link     = event.currentTarget;
    const anchorId = new URL(link.href).hash.replace("#", "");
    const anchor   = document.getElementById(anchorId);
    window.scrollTo({
                      top:      anchor.offsetTop,
                      behavior: "smooth"
                    });
  }
</script>

<Cookies/>

{#if data}
    <div class="container-fluid block">
        <div class="row box">
            <div class="col-10 offset-1 col-lg-8 col-xxl-6 offset-lg-2 offset-xxl-3">
                <h1 class="title">{data.header}</h1>
                <p class="description col-12 my-4">
                    {@html marked(data.description)}
                </p>

                <div class="row">
                    {#each data.buttons as button}
                        <div class="col-12 col-lg-{buttonCols}">
                            <a href={button.href} on:click={handleAnchorClick}>
                                <button class="btn--{button.type} mt-2">{button.label}</button>
                            </a>
                        </div>
                    {/each}
                </div>
            </div>
        </div>

        <div class="d-none d-lg-block col-4 mt-5 visualization" style="--header-background: url('{UPLOADS_DIRECTORY}{data.image.data.attributes.url}')"></div>
    </div>

    <div class="col-12 scroll d-none d-lg-flex">
        <a href="#anchor-patrons" on:click={handleAnchorClick}>
            <i class="ci-chevron_big_down"></i>
        </a>
    </div>
{/if}

<style>
    .visualization {
        background-image: var(--header-background);
        background-size: contain;
        background-position: right;
        background-repeat: no-repeat;
        object-fit: contain;
        height: 80vh;
    }

    .box {
        margin: 0 !important;
    }

    .block {
        display: flex;
        align-items: center;
        min-height: 83vh;
        padding: 0 !important;
        overflow-y: visible;
    }

    .title {
        font-family: "Montserrat";
        font-style: normal;
        font-weight: bold;
        font-size: 48px;
    }

    .description {
        font-family: "Work Sans";
        font-size: 14px;
        line-height: 16px;

        color: #425466;
    }

    .btn--fill {
        background-color: #fdcd18;
        outline: none;
        border: none;
        padding: 15px 0px;
        font-family: "Montserrat";
        font-weight: bold;
        font-size: 13px;
        text-decoration: none;
        color: #425466;
        width: 100%;
        text-transform: uppercase;
    }

    .btn--outline {
        border: 2px solid #fdcd18;
        background-color: white;
        padding: 13px 0px;
        font-family: "Montserrat";
        font-weight: bold;
        font-size: 13px;
        text-decoration: none;
        color: #425466;
        width: 100%;
        text-transform: uppercase;
    }

    .scroll {
        display: flex;
        justify-content: center;
    }

    .scroll a {
        transform: scaleX(1.7);
        font-size: 51px;
        color: #425466;
        text-decoration: none;
    }
</style>
